export enum Colorscheme { //default font color is text-e-dark-green
    light = 'bg-e-white text-e-dark-green',
    white = 'bg-white text-e-dark-green',
    lightgreen = 'bg-e-light-green text-e-dark-green',
    green = 'bg-e-reg-green text-e-dark-green',
    darkgreen = 'bg-e-dark-green text-e-reg-green',
    gold = 'bg-e-gold text-e-dark-green',
    orange = 'bg-e-orange text-white',
    transparent = 'bg-transparent text-e-dark-green'
}

export enum Hovercolorscheme { //default hover:bg-e-reg-green hover:text-e-dark-green
    light = 'hover:bg-e-reg-green hover:text-e-dark-green',
    white = 'hover:bg-e-reg-green hover:text-e-dark-green',
    lightgreen = 'hover:bg-e-reg-green hover:text-e-dark-green',
    green = 'hover:bg-e-light-green hover:text-e-dark-green',
    darkgreen = 'hover:bg-e-reg-green hover:text-e-dark-green',
    gold = 'hover:bg-e-light-green hover:text-e-dark-green',
    orange = 'hover:bg-e-reg-green hover:text-e-dark-green',
    transparent = 'hover:bg-e-reg-green hover:text-e-dark-green'
}

export enum StoryblokColorToColorscheme {
    'e-white' = 'light',
    'white' = 'white',
    'e-dark-green' = 'darkgreen',
    'e-reg-green' = 'green',
    'e-light-green' = 'lightgreen',
    'e-orange' = 'orange',
    'e-gold' = 'gold',
    'transparent' = 'transparent'
}
